  function related_product_replace(replace_arr, product_name) {
    var re_output = product_name;
    var replace_starting_index;
    for( var re of replace_arr ) {
      replace_starting_index = re_output.indexOf(re);
      if( replace_starting_index > -1 ) {
        re_output = re_output.replace(re, '').trim();
      }
    }
    return re_output;
  }

  function get_remove_part(product_type) {
    var remove_part = [];
    if( product_type == '3/4 tights') {
      remove_part.push('3/4 tights for men');
    } else if( product_type == 'arm shiver') {
      remove_part.push('forearm compression sleeve');
    } else if( product_type == '3/4 sleeve') {
      remove_part.push('3/4 arm sleeve');
    } else if( product_type == 'kids arm shiver') {
      remove_part.push('kids forearm sleeve');
    } else if( product_type == 'compression forearm sleeve') {
      remove_part.push('seamless forearm sleeve with grip');
      remove_part.push('seamless forearm sleeve');
    } else if( product_type == 'batting gloves') {
      remove_part.push('batting gloves');
    } else if( product_type == 'hat') {
      remove_part.push('hat');
    } else if( product_type == 'dad hat') {
      remove_part.push('dad hat');
    } else if( product_type == 'trucker hat') {
      remove_part.push('trucker hat');
    } else if( product_type == 'neck gaiter') {
      remove_part.push('neck gaiter');
    } else if( product_type == '2-layer neck gaiter') {
      remove_part.push('2-layer neck gaiter');
    } else if( product_type == 'neck gaiter pro') {
      remove_part.push('pro neck gaiter');
    } else if( product_type == 'neck gaiter packs') {
      remove_part.push('10 pack');
      remove_part.push('neck gaiter');
    } else if( product_type == 'headband') {
      remove_part.push('doublesided headband');
      remove_part.push('double sided headband');
      remove_part.push('headband');
    } else if( product_type == 'hoodie') {
      remove_part.push('throw on hoodie');
      remove_part.push('heavy hoodie');
      remove_part.push('the monk');
      remove_part.push('hoodie');
    } else if( product_type == 'football crop top hoodie') {
      remove_part.push('football crop top hoodie');
    } else if( product_type == 'jersey') {
      remove_part.push('quick-dry jersey');
    } else if( product_type == 'joggers') {
      remove_part.push('joggers');
    } else if( product_type == 'kids shorts') {
      remove_part.push('kids shorts');
    } else if( product_type == 'kids sleeve') {
      remove_part.push('kids arm sleeve');
    } else if( product_type == 'kids knitted sleeve') {
      remove_part.push('kids knitted arm sleeve');
    } else if( product_type == 'kids spats') {
      remove_part.push('kids spats / cleat covers');
    } else if( product_type == 'kids tights') {
      remove_part.push('tights for kids');
      remove_part.push('tight for kids');
    } else if( product_type == 'knee pads') {
      remove_part.push('padded knee sleeve');
    } else if( product_type == 'lanyard') {
      remove_part.push('lanyard');
    } else if( product_type == 'premium lanyard') {
      remove_part.push('premium lanyard');
    } else if( product_type == 'football mouthguard') {
      remove_part.push('soft football mouthguard');
      remove_part.push('x football mouthguard');
      remove_part.push('football mouthguard');
    } else if( product_type == 'padded arm sleeve') {
      remove_part.push('padded arm sleeve');
      remove_part.push('granada / padded arm sleeve');
    } else if( product_type == 'receiver gloves') {
      remove_part.push('sticky football receiver gloves');
    } else if( product_type == 'kids receiver gloves') {
      remove_part.push('sticky kids football receiver gloves');
    } else if( product_type == 'women receiver gloves') {
      remove_part.push('sticky football receiver gloves for women');
    } else if( product_type == 'shorts') {
      remove_part.push('shorts');
    } else if( product_type == 'shorts sleeve jersey') {
      remove_part.push('short sleeve jersey');
    } else if( product_type == 'skull cap') {
      remove_part.push('skull cap');
    } else if( product_type == 'sleeve') {
      remove_part.push('arm sleeve - big');
      remove_part.push('arm sleeve');
    } else if( product_type == 'sleeveless jersey') {
      remove_part.push('sleeveless quick-dry jersey');
    } else if( product_type == 'socks') {
      remove_part.push("over the knee socks");
      remove_part.push("women's long socks");
      remove_part.push("crew socks - 2 pack");
      remove_part.push("half stripe crew socks");
      remove_part.push('casual socks');
      remove_part.push('soft socks');
      remove_part.push('crew socks');
      remove_part.push('socks');
    } else if( product_type == 'sports socks') {
      remove_part.push("football knee-high socks");
      remove_part.push("soccer knee-high socks");
      remove_part.push("baseball knee-high socks");
      remove_part.push("over the knee sport socks");
    } else if( product_type == 'padded socks') {
      remove_part.push("football padded long socks");
      remove_part.push("football padded short socks");
    } else if( product_type == 'kids socks') {
      remove_part.push("football padded long kids socks");
      remove_part.push("football padded short kids socks");
    } else if( product_type == 'spats') {
      remove_part.push('spats / cleat covers');
    } else if( product_type == 'stirrups') {
      remove_part.push('baseball stirrups (socks not included)');
    } else if( product_type == 'tights') {
      remove_part.push('tights for men');
    } else if( product_type == 'single-leg tights') {
      remove_part.push('single-leg basketball tights');
    } else if( product_type == 'generic single-leg tights') {
      remove_part.push('single-leg tights');
    } else if( product_type == 'wide headband') {
      remove_part.push('doublesided headband');
      remove_part.push('double sided headband');
      remove_part.push('headband 2-pack');
      remove_part.push('headband');
    } else if( product_type == 'elastic headband') {
      remove_part.push('non-slip elastic headband');
    } else if( product_type == 'wristband') {
      remove_part.push('motivational wristband');
    } else if( product_type == 'wide wristband') {
      remove_part.push('1 inch wristband');
    } else if( product_type == 'yoga pants') {
      remove_part.push('yoga pants');
    } else if( product_type == 'drip wristband') {
      remove_part.push('drip wristbands (pair)');
      remove_part.push('drip wristband');
    } else if( product_type == 'skull wrap') {
      remove_part.push('skull wrap');
    } else if( product_type == 'football leg sleeves') {
      remove_part.push('football leg sleeves');
      remove_part.push('scrunchie leg sleeves');
    } else if( product_type == 'scrunchie sleeves') {
      remove_part.push('lineman scrunchie leg sleeves');
      remove_part.push('football leg sleeves - big');
    } else if( product_type == 'long leg sleeve') {
      remove_part.push('leg sleeve');
    } else if( product_type == 'kids leg sleeve') {
      remove_part.push('kids leg sleeve');
    } else if( product_type == 'compression shorts') {
      remove_part.push('compression shorts');
    } else if( product_type == 'compression shirt') {
      remove_part.push('compression shirt');
    } else if( product_type == 'compression jersey') {
      remove_part.push('short sleeve compression jersey');
    } else if( product_type == 'football towel' ) {
      remove_part.push('thin football towel with logo');
      remove_part.push('thin football towel');
      remove_part.push('football towel');
    } else if( product_type == 'cotton bicep bands' ) {
      remove_part.push('thin cotton bicep bands');
    } else if( product_type == 'visor' ) {
      remove_part.push('machine silver helmet eye-shield visor');
      remove_part.push('silver moonstone helmet eye-shield visor');
      remove_part.push('clear helmet eye-shield visor');
      remove_part.push('sx2 helmet eye-shield visor');
      remove_part.push('clear sx2 helmet eye-shield visor');
      remove_part.push('helmet eye-shield visor');
    } else if( product_type == 'visor skin' ) {
      remove_part.push('visor skin');
    } else if( product_type == 'visor with skin' ) {
      remove_part.push('sleefs x helmet eye-shield visor with skin ');
    } else if( product_type == 'sticker' ) {
      remove_part.push('stickers for helmet visor tabs');
      remove_part.push('sticker');
    } else if( product_type == 'pullstring bag' ) {
      remove_part.push('drawstring bag');
    } else if( product_type == 'charm' ) {
      remove_part.push('magnetic charm');
    } else if( product_type == 'back plate decal' ) {
      remove_part.push('sticker for back plate');
    } else if( product_type == 'bumper sticker kit' ) {
      remove_part.push('riddell speedflex front and back bumper sticker kit');
    } else if( product_type == 'chin strap cover' ) {
      remove_part.push('chin strap cover');
    } else if( product_type == 'tie headband' ) {
      remove_part.push('tie headband');
    } else if( product_type == 'calf sleeves' ) {
	  remove_part.push('knitted compression calf sleeves');
      remove_part.push('calf sleeves');
    } else if( product_type == 'pro calf sleeves' ) {
	  remove_part.push('pro calf sleeve (single)');
      remove_part.push('pro calf sleeves');
    }else if( product_type == 'running sleeves' ) {
      remove_part.push('running sleeves');
    } else if( product_type == 'cooling towel' ) {
      remove_part.push('cooling towel');
    } else if( product_type == 'ninja headband' ) {
      remove_part.push('ninja headband');
    } else if( product_type == 'kids ninja headband' ) {
      remove_part.push('kids ninja headband');
    } else if( product_type == 'cotton headband' ) {
      remove_part.push('cotton headband');
    } else if( product_type == 'cotton wristband' ) {
      remove_part.push('cotton wristband');
    } else if( product_type == 'slides' ) {
      remove_part.push('slides');
    } else if( product_type == 'bat grip' ) {
      remove_part.push('bat grip');
    } else if( product_type == 'durag' ) {
      remove_part.push('durag');
    } else if( product_type == 'sports durag' ) {
      remove_part.push('sports durag');      
    } else if( product_type == 'pro sports durag' ) {
      remove_part.push('pro sports durag');      
    } else if( product_type == 'kids durag' ) {
      remove_part.push('kids sports durag');      
    } else if( product_type == 'turf tape' ) {
      remove_part.push('turf tape');
    } else if( product_type == 'spatting tape' ) {
      remove_part.push('spatting tape');
    } else if( product_type == 'leg sleeve' ) {
      remove_part.push('leg sleeve');
    } else if( product_type == 'soccer leg sleeves' ) {
      remove_part.push('long soccer leg sleeves');
    } else if( product_type == 'mask diy' ) {
      remove_part.push('diy face mask');
    } else if( product_type == 'mask with filter pocket' ) {
      remove_part.push('face mask with filter pocket');
    } else if( product_type == 'mask with nose shape' ) {
      remove_part.push('face mask with nose shape');
    } else if( product_type == 'kids mask' ) {
      remove_part.push('kids face mask with nose shape');
      remove_part.push('kids flat face mask');
    } else if( product_type == 'underwear' ) {
      remove_part.push("men's underwear");
      remove_part.push("dirty boxers men's underwear");
    } else if( product_type == 'kids neck gaiter' ) {
      remove_part.push('kids neck gaiter');
    } else if( product_type == 'mask antibacterial' ) {
      remove_part.push('reusable antibacterial face mask');
    } else if( product_type == 'mask stretch string' ) {
      remove_part.push('stretch string face mask');
    } else if( product_type == 'mask stretch string nose shape' ) {
      remove_part.push('stretch string face mask with nose shape');
    } else if( product_type == 'mask lanyard' ) {
      remove_part.push('mask holder / necklace');
    } else if( product_type == 'ski mask' ) {
      remove_part.push('ski mask');
    } else if( product_type == 'necklace' ) {
      remove_part.push('pendant with chain necklace - 18k gold plated stainless steel');
      remove_part.push('pendant with chain necklace - stainless steel');
    } else if( product_type == 'earring' ) {
      remove_part.push('earring - 18k gold plated stainless steel');
      remove_part.push('earring - stainless steel');
    } else if( product_type == 'ring' ) {
      remove_part.push('ring');
    } else if( product_type == 'drip bicep bands' ) {
      remove_part.push('drip bicep bands');
    } else if( product_type == 'kids football leg sleeves' ) {
      remove_part.push('kids scrunchie leg sleeves');
    } else if( product_type == 'x football mouthguard' ) {
      remove_part.push('x football mouthguard with logo');
      remove_part.push('x football mouthguard');
    } else if( product_type == 'kids football mouthguard' ) {
      remove_part.push('kids football mouthguard');
    } else if( product_type == 'pro leg sleeve' ) {
      remove_part.push('pro leg sleeve');
    } else if( product_type == 'football pro leg sleeve' ) {
      remove_part.push('football pro leg sleeve');
    } else if( product_type == 'pro sleeve' ) {
      remove_part.push('pro arm sleeve - big');
      remove_part.push('pro arm sleeve');
    } else if( product_type == 'knee pad' ) {
      remove_part.push('knee pad');
    } else if( product_type == 'compression sleeve' ) {
      remove_part.push('football compression arm sleeve');
      remove_part.push('basketball compression arm sleeve');
      remove_part.push('baseball compression arm sleeve');
      remove_part.push('compression arm sleeve');
      remove_part.push('one size fits all arm sleeve');
    } else if( product_type == 'football arm sleeve' ) {
      remove_part.push('football compression arm sleeve');
    } else if( product_type == 'kids tie headband' ) {
      remove_part.push('kids tie headband');
    } else if( product_type == 'kids headband' ) {
      remove_part.push('kids headband');
    } else if( product_type == 'turban headband' ) {
      remove_part.push('turban twisted headband');
    } else if( product_type == 'compression hoodie' ) {
      remove_part.push('sleeveless compression hoodie');
    } else if( product_type == 'head bag' ) {
      remove_part.push('head bag mask');
    } else if( product_type == 'balaclava' ) {
      remove_part.push('shiesty mask');
    } else if( product_type == 'kids balaclava' ) {
      remove_part.push('kids shiesty mask');
    } else if( product_type == '3 hole ski balaclava' ) {
      remove_part.push('3 hole ski mask');
    } else if( product_type == 'keychain' ) {
      remove_part.push('keychain');
    } else if( product_type == 'backpack' ) {
      remove_part.push('backpack');
    } else if( product_type == 't-shirt' ) {
      remove_part.push('tri-blend t-shirt');
      remove_part.push('t-shirt');
    } else if( product_type == 'bonnet' ) {
      remove_part.push('bonnet');
    } else if( product_type == 'scrunchie socks' ) {
      remove_part.push('long scrunchie socks');
    } else if( product_type == 'scrunchie sock extensions' ) {
      remove_part.push('scrunchie sock extensions');
    } else if( product_type == 'loose-fitting balaclava' ) {
      remove_part.push('loose-fitting shiesty mask');
      remove_part.push('loose-fitting balaclava');
    } else if( product_type == 'quick dry shirt' ) {
      remove_part.push('quick dry shirt');
    } else if( product_type == 'shin guards' ) {
      remove_part.push('soccer shin guards');
    } else if( product_type == 'beanie' ) {
      remove_part.push('beanie');
    }

    return remove_part;
  }

  function send_sold_out(product_variant, email_address, customer_accepts_marketing, product_id) {
    customer_accepts_marketing = customer_accepts_marketing ? true : false;
    var notificationCallback = function(data) {
      var msg = '';
      if (data.status == 'OK') {
        msg = data.message; // just show the success message
        if(msg!=""){
          document.getElementById("success-msg").style.display = "";
          //document.getElementById("error-msg").style.display = "none";
          $("#error-msg").hide();
          document.getElementById("show-success-msg").innerHTML =  msg;
        }
      } else { // it was an error
        for (var k in data.errors) {  // collect all the error messages into a string
          msg += (k + " " + data.errors[k].join());
        }
        //alert(msg);
        $("#success-msg").hide();
        document.getElementById("error-msg").style.display = "";
        document.getElementById("show-error-msg").innerHTML =  msg;
      }
    }

    BIS.create(email_address, product_variant, product_id, { accepts_marketing: customer_accepts_marketing }).then(notificationCallback);

  }

  $(document).ready(function() {
    function readURL(input) {
      if (input.files && input.files[0]) {
        var reader = new FileReader();
  
        reader.onload = function(e) {
          $('#upload-preview').attr('src', e.target.result);
        }
  
        reader.readAsDataURL(input.files[0]);
        $('.delete-preview-ct').show();
      }
    }

    $(".sl-upload__input").change(function() {
      readURL(this);
    });
    
    $('.delete-preview').on('click', function(){
  	$('#upload-preview').attr('src', '');
      $('.sl-upload__input').val('');
      $('.delete-preview-ct').hide();
    });
  
    $('.additional_buy').on('click', function(){
    var _this = $(this);
    var te = _this.text();
    _this.text('Adding...');
    var request  = "quantity=1&id="+_this.data('variant_id');
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: request})
    .then(function(){
      _this.text(te);
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {

          }
        }));

    })
    .fail(function (error) {
      $(this).text(te);
    });
  }); 
  });

  //Added by @maomuriel 20190828, ID: c3a64317-397f-43ed-853e-837c5d11055a
  $(document).ready(function(){
    $('.drawer').navigationSidebar();
    $('.sl-upload--text').on('click', function(e){
      $(this).siblings('.sl-upload__input').click();
    });
  
    $('.swatch_custom_number').on('click', function(e){
      $(this).toggleClass("swatch__item--active");
  
      if($(this).hasClass("swatch__item--active")){
        $('.custom_number_wrapper').show();
        $("#_custom-number-color").val("black");
      }else {
        $('.custom_number_wrapper').hide();
        $("#_custom-number-color").val("");
      }
    });
  
    $('.sublink_listitem[data-image-url]').hover(function(){
      $(this).parents('.submenu_container').find('.sublink_preview img').attr('src', $(this).data('image-url'));
    });
  
    
    $('button.cart__update').on('click',function(e){
    $('input[data-xmd5 ^= "addnumber_"]').prop( "disabled", false);    
    });
    $('input[data-xmd5 ^= "addnumber_"]').prop( "disabled", true );
    $('a[data-xmd5 ^= "addnumber_"]').prop( "disabled", true );  
    
    window.cartCustomHelper = window.cartCustomHelper || {};
  
    (function($,theme){
        var theme = theme;
        var $ = jQuery = $;
        
        var regexpIsCustomType = /_/;
    
        //It registers the onClick event handler for "Remove" buttons
        $('p.cart__product-meta > a[href^="/cart/change"]').on("click",null,function(e){
          e.preventDefault();
          var targetEle = e.target;
          var relatedProduct = null;
          if (targetEle.nodeName != 'a' && targetEle.nodeName != 'A'){
            targetEle = targetEle.parentNode;
          }
          if (targetEle.getAttribute("data-xmd5") != 'undefined' && targetEle.getAttribute("data-xmd5") != null){
              
              //relatedProduct = localCartDrawer.getFullRelatedProducts(targetEle.getAttribute("data-xmd5"),"input.cart__product-qty");
              relatedProduct = sleefsCustomCartHelper(targetEle.getAttribute("data-xmd5"),"input.cart__product-qty");
              let mainInputElement = {};
              if (relatedProduct == null){
                window.location = targetEle.getAttribute("href");
                return true;
              }
            
              mainInputElement = $(targetEle).parents('div.cart__row').find('input[data-xmd5="'+targetEle.getAttribute("data-xmd5")+'"]').get(0);
            
              if(relatedProduct.principalIsMain){
                
                var newCustomQty = parseInt(-1 * parseInt(mainInputElement.value));
                
                theme.cart.changeItem(mainInputElement.getAttribute('data-id'),0).then(function(cart){
                  theme.cart.changeItem(relatedProduct.customRelated.getAttribute('data-id'),newCustomQty).then(function(){
                   window.location = '/cart'; 
                  }.bind(this));
                }.bind(this));
  
              }
          }
          else{
            window.location = targetEle.getAttribute("href");
          }
        }.bind(this));
        
        //It syncs 
        $('input.cart__product-qty').on("change",function(e){
          e.preventDefault();
          var targetEle = e.target;
          var relatedProduct = null;
          if (targetEle.getAttribute("data-xmd5") != 'undefined' && targetEle.getAttribute("data-xmd5") != null){
              //relatedProduct = localCartDrawer.getFullRelatedProducts(targetEle.getAttribute("data-xmd5"),"input.cart__product-qty");
              relatedProduct = sleefsCustomCartHelper(targetEle.getAttribute("data-xmd5"),"input.cart__product-qty");
              if (relatedProduct == null){
                return true;
              } 
              
              if (relatedProduct.principalIsMain){
          var newCustomQty = 0;
          newCustomQty = $(targetEle)[0].value;
                  for (var i = 0 ; i < relatedProduct.mainRelated.length; i++){
                    
                    if (relatedProduct.mainRelated[i].id != $(targetEle)[0].id){
                      newCustomQty = parseInt(parseInt(newCustomQty) + parseInt(relatedProduct.mainRelated[i].value));
                    }
                  }
                  relatedProduct.customRelated.value=newCustomQty;
              }
              else{
              }
          }
        }.bind(this));
        
      })(jQuery,window.theme)
  
  });
  //End ID: c3a64317-397f-43ed-853e-837c5d11055a
  
  //Added by @maomuriel 20200224, ID: FD72AA6FC5DC72DF00884F935FE82078
  var sleefsCustomCartHelper = function(xmd5Id,itemsSelector){   
      var regexpToDetect = /_/;
      var productType = 'main';
      var regexpToCompare = '';
      var objToReturn = {
        principalIsMain: true,
        customRelated : {},
        mainRelated: []
      };
      if (regexpToDetect.exec(xmd5Id)){
        productType = 'custom';
        objToReturn.principalIsMain = false;
      }
  
      if (productType == 'custom'){
        var tmpArr = xmd5Id.split("_");
        xmd5Id = tmpArr[1];
      }  
      regexpToCompare = new RegExp('_'+xmd5Id);
  
  
      var inputCartElements = document.querySelectorAll(itemsSelector);
      for (var i = 0; i < inputCartElements.length; i++){
  
        if (inputCartElements[i].getAttribute('data-xmd5') != null){ 
          if (regexpToCompare.exec(inputCartElements[i].getAttribute('data-xmd5'))){
            objToReturn.customRelated = inputCartElements[i];
          }
          else if (inputCartElements[i].getAttribute('data-xmd5') == xmd5Id){
            objToReturn.mainRelated.push(inputCartElements[i]);
          }
        }
  
      }
    return objToReturn; 
  }
  //End ID: 

  $(window).scroll(function() {  
      if($('.ais-InfiniteHits-loadMore').length) {
        if(($('.ais-InfiniteHits-loadMore').position().top - $(this).scrollTop() - $(this).height() ) < 5) {
          $('.ais-InfiniteHits-loadMore').trigger('click');
        }
      }
  });
  
  if($.isFunction(window.Ajaxinate)){
    document.addEventListener("DOMContentLoaded", function() {
    var endlessScroll = new Ajaxinate({
      container: '#Huratips-Loop',
      pagination: '#Huratips-Pagination'
    });
    AOS.init();
    });
  }
  
  /**
   * Plugin for handling the sidebar
   */
  (function ($) {
    var methods = {
      /**
       * Navigation sidebar
       */
      navigationSidebar: null,
  
      /**
       * Cached selector that represents the name of the current level
       */
      navigationSidebarCurrent: null,
  
      /**
       * Current navigation level
       */
      navigationCurrentLevel: null,
  
      /**
       * Page overlay
       */
      pageOverlay: null,
  
      /**
       * Body element
       */
      body: null,
  
      init: function() {
        methods.navigationSidebar = $(this);
        methods.navigationSidebarCurrent = methods.navigationSidebar.find('.drawer__navdrawer.drawer__title');
        methods.pageOverlay = $('.page__overlay');
        methods.body = $('body');
  
        methods.navigationSidebar.find('.navigation-sidebar__top').css('height', $('.header__wrapper').height() + 1 + 'px');
  
          // This is necessary to compensate the additional height of top bar, due to the way flexbox works
          methods.navigationSidebar.find('.navigation-sidebar__list').each(function() {
            $(this).find('.navigation-sidebar__item').filter(':visible:last').css('margin-bottom', $('.informational-bar').innerHeight() + 'px');
          });
  
  
  //       $('[data-action="open-navigation-sidebar"], [data-action="close-navigation-sidebar"]').on('click', $.proxy(methods.toggleNavigationSidebar, this));
  
        $('.drawer__rewind').on('click', $.proxy(methods.rewindNavigationSidebar, this));
        methods.navigationSidebar.find('.navigation-sidebar__item--expandable > .navigation-sidebar__link').on('click', $.proxy(methods.openNextLevel, this));
      },
      
      /**
       * Toggle the navigation sidebar
       */
      toggleNavigationSidebar: function() {
        methods.navigationSidebar.toggleClass('navigation-sidebar--open');
        methods.navigationSidebar.css('margin-top', $('.header__wrapper')[0].getBoundingClientRect().top);
        methods.pageOverlay.toggleClass('page__overlay--open');
        methods.body.toggleClass('no-scroll');
  
        if (methods.navigationSidebar.hasClass('navigation-sidebar--open')) {
          methods.pageOverlay.one('click', $.proxy(methods.closeNavigationSidebar, this));
        } else {
          methods.pageOverlay.off('click');
        }
  
        return false;
      },
  
      /**
       * Close the navigation sidebar
       */
      closeNavigationSidebar: function() {
        methods.navigationSidebar.removeClass('navigation-sidebar--open');
        methods.pageOverlay.removeClass('page__overlay--open').off('click');
        methods.body.removeClass('no-scroll');
      },
      /**
       * Rewind to the previous level
       */
      rewindNavigationSidebar: function() {
        var parentLevel = methods.navigationSidebar.find('[data-nav-for="' + methods.navigationCurrentLevel.attr('data-parent-nav') + '"]');
  
        methods.navigationCurrentLevel.removeClass('navigation-sidebar__list--active');
        parentLevel.removeClass('navigation-sidebar__list--hidden');
  
        // If the current navigation level is 1, this means that the next one is 0, so we show again the cross
        if (parentLevel.attr('data-nav-for') === 'main-menu') {
          $('.drawer__rewind').hide();
          methods.navigationSidebarCurrent.text('Categories');
        } else {
          methods.navigationSidebarCurrent.text(parentLevel.attr('data-nav-name'));
        }
  
        methods.navigationCurrentLevel = parentLevel;
  
        return false;
      },
  
      /**
       * Open the next level
       */
      /*openNextLevel: function(event) {
        var element = $(event.currentTarget),
            currentLevel = element.closest('.navigation-sidebar__list'),
            subNav = element.attr('data-open-nav'),
            nextLevel = methods.navigationSidebar.find('[data-nav-for="' + subNav + '"]');
  
        // We need to take the next nav, and push it
        nextLevel.addClass('navigation-sidebar__list--active').attr('data-parent-nav', currentLevel.attr('data-nav-for'));
        currentLevel.addClass('navigation-sidebar__list--hidden');
  
        $('.drawer__rewind').show();
  
        methods.navigationCurrentLevel = nextLevel;
        methods.navigationSidebarCurrent.text(nextLevel.attr('data-nav-name'));
  
        return false;
      }*/
     openNextLevel: function(event) {

  var element = $(event.currentTarget),
      subNav = element.attr('data-open-nav');

  // ⛔ SI NO TIENE SUBMENU → NAVEGA NORMAL
  if (!subNav) {
    return true;
  }

  var currentLevel = element.closest('.navigation-sidebar__list'),
      nextLevel = methods.navigationSidebar.find('[data-nav-for="' + subNav + '"]');

  // ⛔ SI NO EXISTE ESE NIVEL → NAVEGA NORMAL
  if (!nextLevel.length) {
    return true;
  }

  // ✅ SOLO AQUI PREVENIMOS
  event.preventDefault();

  nextLevel
    .addClass('navigation-sidebar__list--active')
    .attr('data-parent-nav', currentLevel.attr('data-nav-for'));

  currentLevel.addClass('navigation-sidebar__list--hidden');

  $('.drawer__rewind').show();

  methods.navigationCurrentLevel = nextLevel;
  methods.navigationSidebarCurrent.text(nextLevel.attr('data-nav-name'));

  return false;
}
    };
  
    $.fn.navigationSidebar = function(options) {
      return methods.init.call(this, options);
    };
  }(jQuery));

  document.addEventListener("DOMContentLoaded", function () {
    function checkSelects() {
      document.querySelectorAll(".lb-variant-picker").forEach(select => {
        if (select.options.length <= 1) {
          select.style.display = "none"; 
        } else {
          select.style.display = "block"; 
        }
      });
    }
    checkSelects();
    const observer = new MutationObserver(checkSelects);
    observer.observe(document.body, { childList: true, subtree: true });
  });

  document.addEventListener("DOMContentLoaded", function () {
    const link = document.querySelector('.link-size-chart');
    const target = document.querySelector('.product__notabs-content--sizes');

    if (link && target) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  });

  document.addEventListener("DOMContentLoaded", function () {
    const link2 = document.querySelector('.read-reviews');
    const target2 = document.querySelector('.product__notabs-content--reviews-content');

    if (link2 && target2) {
      link2.addEventListener('click', function (e) {
        e.preventDefault();
        target2.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  });


/********** Custom Dropdown *************/

document.addEventListener('DOMContentLoaded', function() {
  const selected = document.getElementById('beanies-selected');
  const list = document.getElementById('beanies-list');
  const selectedImg = document.getElementById('selected-img');
  const selectedTitle = document.getElementById('selected-title');
  
  if (!selected || !list) return;
  // Mostrar / ocultar lista
  selected.addEventListener('click', function() {
    list.classList.toggle('visible');
  });

  // Selección de producto
  document.querySelectorAll('.beanie-option').forEach(option => {
    option.addEventListener('click', function() {
      const img = this.getAttribute('data-image');
      const title = this.getAttribute('data-title');
      const url = this.getAttribute('data-url');

      selectedImg.src = img;
      selectedTitle.textContent = title;
      list.classList.remove('visible');

      // Redirige al producto seleccionado
      window.location.href = url;
    });
  });

  // Cerrar dropdown si se hace clic fuera
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.beanies-dropdown')) {
      list.classList.remove('visible');
    }
  });
});

/****************** Cart Drawer - Free Shipping ****************/

document.addEventListener('DOMContentLoaded', function() {
  const FREE_SHIPPING_THRESHOLD = 45;
  // Función principal: actualiza barra y texto
  theme.cart.updateFreeShippingBar = function(cart) {
    const barContainer = document.querySelector('.free-shipping-bar');
    const bar = document.querySelector('.progress-bar');
    const text = document.querySelector('.free-shipping-text');

    if (!barContainer || !bar || !text) return;

    // Ocultar si el carrito está vacío
    if (cart.item_count === 0) {
      barContainer.style.display = 'none';
      return;
    } else {
      barContainer.style.display = 'block';
    }

    const subtotal = cart.total_price / 100; // Shopify usa centavos
    const amountLeft = Math.max(0, FREE_SHIPPING_THRESHOLD - subtotal);
    const progress = Math.min(100, (subtotal / FREE_SHIPPING_THRESHOLD) * 100);

    bar.style.width = progress + '%';

    if (amountLeft <= 0) {
      text.innerHTML = "🎉 You've got <strong>FREE shipping!</strong>";
    } else {
      text.innerHTML = `Spend <span class="amount-left">$${amountLeft.toFixed(2)}</span> more to get <strong>FREE shipping!</strong>`;
    }
  };

  // Inicializar al cargar o abrir el drawer
  theme.cart.initFreeShipping = function() {
    theme.cart.getCart().then(cart => {
      theme.cart.updateFreeShippingBar(cart);
    });
  };

  // Interceptar TODAS las actualizaciones del carrito
  const originalUpdateCart = theme.cart._updateCart;
  theme.cart._updateCart = function(params) {
    return originalUpdateCart.call(this, params).then(response => {
      // Cuando el carrito cambia, obtener el nuevo estado
      theme.cart.getCart().then(cart => {
        theme.cart.updateFreeShippingBar(cart);
      });
      return response;
    });
  };

  // Inicializar en la carga de la página
  theme.cart.initFreeShipping();


  ['ajaxProduct:added', 'cart:build', 'cart:updated', 'cart:open', 'cart:refresh'].forEach(evt => {
    document.addEventListener(evt, () => {
      theme.cart.getCart().then(cart => theme.cart.updateFreeShippingBar(cart));
    });
  });
});

/****************** Dropdown Colors  ****************/

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.variant-wrapper-custom--dropdown .colors-dropdown').forEach(dropdown => {
    const selected = dropdown.querySelector('.selected-item');
    const list = dropdown.querySelector('.colors-list');

    if (!selected || !list) return;

    selected.addEventListener('click', () => {
      dropdown.classList.toggle('open');
    });

    list.querySelectorAll('.color-option').forEach(option => {
      option.addEventListener('click', () => {
        const value = option.dataset.value;

        const radio = document.querySelector(
          `input[data-variant-input][value="${CSS.escape(value)}"]`
        );

        if (radio) {
          radio.click();
        }

        dropdown.classList.remove('open');
      });
    });

    document.addEventListener('click', e => {
      if (!dropdown.contains(e.target)) {
        dropdown.classList.remove('open');
      }
    });
  });
});

/****************** Dropdown main menu ****************/
document.addEventListener('DOMContentLoaded', function() {
  document
    .querySelectorAll('.navigation-sidebar__dropdown-trigger')
    .forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        this.parentElement.classList.toggle('active');
      });
    });
});